"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { addToRecentViews } from "@/lib/utils/recentViewsUtils";

/**
 * Client component to track and store recent views when a profile page loads
 * This ensures the data is stored only when the user actually views the profile
 */
export default function RecentViewsTracker(t0) {
  const $ = _c(4);
  const {
    digitalProfile,
    profileId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== digitalProfile || $[1] !== profileId) {
    t1 = () => {
      if (!digitalProfile || !profileId) {
        return;
      }
      const digitalProfileUrl = `/digital-profile/${profileId}?isLeadGenProfile=true`;
      const contractorData = {
        id: profileId,
        name: digitalProfile?.profileName || "",
        work_experience: +digitalProfile?.workExperience || 0,
        digitalProfileUrl,
        profileImageUrl: digitalProfile?.profilePicture || "/assets/user_avatar.avif",
        project_photo_count: digitalProfile?.project_count || 0
      };
      addToRecentViews(contractorData);
    };
    t2 = [digitalProfile, profileId];
    $[0] = digitalProfile;
    $[1] = profileId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}